<modal-panel title="Service Details" (close)="closeDialog()">
  <app-kt-service-detail [data]="data.id"></app-kt-service-detail>
  <ng-container modalPanelFooter>
    <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
  </ng-container>
</modal-panel>
